import { render, staticRenderFns } from "./CardError.vue?vue&type=template&id=4dcb464f&scoped=true"
import script from "./CardError.vue?vue&type=script&lang=js"
export * from "./CardError.vue?vue&type=script&lang=js"
import style0 from "./CardError.vue?vue&type=style&index=0&id=4dcb464f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb464f",
  null
  
)

export default component.exports